import axios from "axios";
import config from "../../config.json";

const BASE_URL = config.dev;

const getAuthHeaders = () => {
  const token = localStorage.getItem("tokenLogin");
  if (!token) throw new Error("No authentication token found. Please log in again.");
  return { Authorization: `Bearer ${token}` };
};

export const fetchAllEvents = async ({
  page = 1,
  limit = 100,
  archived = false,
  search = "",
} = {}) => {
  const response = await axios.get(`${BASE_URL}/events/all`, {
    params: { page, limit, archived, search },
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const saveEvent = async ({ payload, file, id }) => {
  const formData = new FormData();
  formData.append("data", JSON.stringify(payload));
  if (file) {
    formData.append("file", file, file.name || "event-image.webp");
  }

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "multipart/form-data",
  };

  if (id) {
    const response = await axios.put(`${BASE_URL}/events/${id}`, formData, { headers });
    return response.data;
  }

  const response = await axios.post(`${BASE_URL}/events/create`, formData, { headers });
  return response.data;
};

export const updateEvent = async (id, payload) => {
  const response = await axios.put(`${BASE_URL}/events/${id}`, payload, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const updateEventArchive = async (id, archived) => {
  const response = await axios.put(
    `${BASE_URL}/events/archive/${id}`,
    { archived },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const republishEvent = async (id) => {
  const response = await axios.put(`${BASE_URL}/events/republish/${id}`, {}, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteEvent = async (id) => {
  const response = await axios.delete(`${BASE_URL}/events/${id}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const updateEventsOrder = async (eventIds) => {
  const response = await axios.put(
    `${BASE_URL}/events/update-order`,
    { eventIds },
    { headers: getAuthHeaders() }
  );
  return response.data;
};
